// extracted by mini-css-extract-plugin
export var backgroundImage = "_g-1";
export var container = "_g-0";
export var title = "_g-2";